import React, { useState } from 'react';
import { Localizer } from 'services/Localizer';
import Modal from 'shared/components/Modal';
import { CalculatorType } from 'features/commerce/calculators/quote-confirmation/types';
import CardButton from 'shared/components/card/CardButton';
import {
	ABRASIVE_BELT_CALCULATOR_URL,
	CUSTOM_CUT_SHAPES_CALCULATOR_URL,
	CUSTOM_SHORT_LENGTH_CALCULATOR_URL,
	CUSTOM_WIDTH_ROLL_CALCULATOR_URL,
} from 'features/commerce/calculators/routes';

export interface ProductCalculatorSelectorProps {
	availableCalculators: CalculatorType[];
}

const renderCalculatorLink = (calculatorType: CalculatorType) => {
	let linkDescription: string | undefined;
	let calculatorUrl: string | undefined;
	switch (calculatorType) {
		case CalculatorType.AbrasiveBelts:
			linkDescription = Localizer('CustomAbrasiveBeltsCalculatorOptionDescription');
			calculatorUrl = ABRASIVE_BELT_CALCULATOR_URL;
			break;
		case CalculatorType.CustomCutTapeShape:
			linkDescription = Localizer('CustomCutShapesCalculatorOptionDescription');
			calculatorUrl = CUSTOM_CUT_SHAPES_CALCULATOR_URL;
			break;
		case CalculatorType.CustomShortLength:
			linkDescription = Localizer('CustomShortLengthCalculatorOptionDescription');
			calculatorUrl = CUSTOM_SHORT_LENGTH_CALCULATOR_URL;
			break;
		case CalculatorType.CustomWidthRoll:
			linkDescription = Localizer('CustomWidthRollCalculatorOptionDescription');
			calculatorUrl = CUSTOM_WIDTH_ROLL_CALCULATOR_URL;
			break;
	}

	return <a href={calculatorUrl}>{linkDescription}</a>;
};

/**
 * The main component for rendering Product Calculator Selector.
 */
export function ProductCalculatorSelector(props: ProductCalculatorSelectorProps) {
	const { availableCalculators } = props;
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<>
			<CardButton
				onClick={() => {
					setIsModalOpen(true);
				}}
				data-testid={`product-available-calculators-button`}
			>
				{Localizer('ProductCalculatorSelection')}
			</CardButton>

			<Modal
				isOpen={isModalOpen}
				closeModal={() => {
					setIsModalOpen(false);
				}}
				renderTitle={() => null}
				headerDivider={false}
				size="xlg"
			>
				<ul>
					{availableCalculators.map((calculator) => {
						return <li key={calculator}>{renderCalculatorLink(calculator)}</li>;
					})}
				</ul>
			</Modal>
		</>
	);
}
